import { useQuery } from "@tanstack/react-query";
import { Checkbox, Form, Radio, Select, Spin } from "antd";
import { useIntl } from "react-intl";
import { ListCateBlogAdmin, getLocationsAdmin } from "../../../network/admin";
import StatusItemForm from "./StatusItemForm";

const FilterBodyForm = ({
  status,
  status2,
  status3,
  dateAdded,
  salonType,
  bySalon,
  gender,
  stock,
  price,
  tags,
}: any) => {
  const { data, isLoading } = useQuery(["AdminLocations"], () =>
    getLocationsAdmin()
  );
  const { data: cates, isLoading: loadeCates } = useQuery(["categories"], () =>
    ListCateBlogAdmin({}, false)
  );
  const options: any = data?.data?.map((item: any, i: any) => ({
    label: item?.name,
    value: item?.id,
  }));
  const intl = useIntl();
  const { locale } = useIntl();
  return (
    <div className="FilterSuperAdmin">
      {/* {price && (
        <>
          <div>
            <div className="text-sm font-medium">القيمة</div>
            <Form.Item
              name={["amount", "from"]}
              label={<div className="text-sm font-medium">من</div>}
              noStyle
              rules={[
                {
                  type: "number",
                  min: 1,
                  message: "Minimum price must be zero or greater.",
                },
              ]}
            >
              <Input
                style={{ width: "50%", textAlign: "center" }}
                type="number"
              />
            </Form.Item>
            <Form.Item
              name={["amount", "to"]}
              label={<div className="text-sm font-medium">الى</div>}
              noStyle
              rules={[
                {
                  type: "number",
                  min: 0,
                  message: "Minimum price must be zero or greater.",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const fromValue = getFieldValue(["amount", "from"]);
                    if (!value || value > fromValue) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        `The "to" value must be greater than the "from" value (${fromValue}).`
                      )
                    );
                  },
                }),
              ]}
            >
              <Input
                style={{ width: "50%", textAlign: "center" }}
                type="number"
              />
            </Form.Item>
          </div>
        </>
      )} */}
      {/* Status */}
      {status && (
        <Form.Item
          name="status"
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "status_label" })}
            </div>
          }
        >
          <Checkbox.Group>
            <StatusItemForm
              label={intl.formatMessage({ id: "status_pending" })}
              value="Pending"
            />
            <StatusItemForm
              label={intl.formatMessage({ id: "status_active" })}
              value="Active"
            />
            <StatusItemForm
              label={intl.formatMessage({ id: "status_blocked" })}
              value="Blocked"
            />
          </Checkbox.Group>
        </Form.Item>
      )}
      {tags && (
        <Form.Item
          name="category_id"
          label={
            <div className="text-sm font-medium capitalize">categories</div>
          }
          className="max-w-[400px]"
        >
          <Checkbox.Group className="flex flex-wrap items-center gap-2">
            {loadeCates ? (
              <Spin className="flex items-center justify-center" />
            ) : (
              cates?.data?.map((e: any) => (
                <StatusItemForm
                  label={typeof e.name === "object" ? e.name[locale] : e.name}
                  value={e.id}
                />
              ))
            )}
          </Checkbox.Group>
        </Form.Item>
      )}
      {status2 && (
        <Form.Item
          name="status"
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "status_label" })}
            </div>
          }
        >
          <Checkbox.Group>
            <StatusItemForm
              label={intl.formatMessage({ id: "Created" })}
              value="created"
            />
            {/* <StatusItemForm
              label={intl.formatMessage({ id: "status_in_progress" })}
              value="arrived"
            /> */}
            <StatusItemForm
              label={intl.formatMessage({ id: "Completed" })}
              value="completed"
            />
            <StatusItemForm
              label={intl.formatMessage({ id: "Canceled" })}
              value="canceled"
            />
          </Checkbox.Group>
        </Form.Item>
      )}
      {/* bySalon*/}
      {bySalon && (
        <Form.Item
          label={<div className="text-sm font-medium">By Salon</div>}
          name="location_ids"
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Please select"
            // defaultValue={["a10", "c12"]}
            // onChange={handleChange}
            options={options}
          />
        </Form.Item>
      )}
      {/* status3 */}
      {/* Date Added */}
      {dateAdded && (
        <Form.Item
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "date_added_label" })}
            </div>
          }
          name="created_at"
        >
          <Radio.Group defaultValue="">
            <Radio className="rounded-sm" value="newest">
              <span>
                {intl.formatMessage({ id: "date_added_newest_to_oldest" })}
              </span>
            </Radio>
            <Radio value="oldest">
              <span>
                {intl.formatMessage({ id: "date_added_oldest_to_newest" })}
              </span>
            </Radio>
          </Radio.Group>
        </Form.Item>
      )}
      {/* {price && (
        <>
          <div>القيمة</div>
          <Form.Item
            label={<div className="text-sm font-medium">from</div>}
            name={["value", "from"]}
          >
            <input type="text" />
          </Form.Item>
          <Form.Item
            label={<div className="text-sm font-medium">to</div>}
            name={["value", "to"]}
          >0ext" />
          </Form.Item>
        </>
      )} */}
      {/* Salon Type */}
      {salonType && (
        <Form.Item
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "salon_type_label" })}
            </div>
          }
          name="salon_type"
        >
          <Radio.Group>
            <Radio value="onsite">
              <span className="badge badge-info">
                {intl.formatMessage({ id: "salon_type_onsite" })}
              </span>
            </Radio>
            <Radio value="freelancer">
              <span className="badge badge-light">
                {intl.formatMessage({ id: "salon_type_freelancer" })}
              </span>
            </Radio>
          </Radio.Group>
        </Form.Item>
      )}{" "}
      {status3 && (
        <Form.Item
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "status_label" })}
            </div>
          }
          name="status"
        >
          <Radio.Group defaultValue="">
            <Radio className="rounded-sm" value="in_store_online">
              <span>{intl.formatMessage({ id: "status_online" })}</span>
            </Radio>
            <Radio value="in_store_only">
              <span>{intl.formatMessage({ id: "status_offline" })}</span>
            </Radio>
            <Radio value="online&offline">
              <span>{intl.formatMessage({ id: "status_online_offline" })}</span>
            </Radio>
          </Radio.Group>
        </Form.Item>
      )}
      {/* gender */}
      {gender && (
        <Form.Item
          label={
            <div className="text-sm font-medium">
              {intl.formatMessage({ id: "services_gender_label" })}
            </div>
          }
          name="available_for"
        >
          <Radio.Group defaultValue="">
            <Radio className="rounded-sm" value="man">
              <span>
                {intl.formatMessage({ id: "services_gender_for_men" })}
              </span>
            </Radio>
            <Radio value="woman">
              <span>
                {intl.formatMessage({ id: "services_gender_for_women" })}
              </span>
            </Radio>
            <Radio value="both">
              <span>
                {intl.formatMessage({ id: "services_gender_for_both" })}
              </span>
            </Radio>
          </Radio.Group>
        </Form.Item>
      )}
      {stock && (
        <Form.Item
          name="stock"
          label={<div className="text-sm font-medium">stock</div>}
        >
          <Checkbox.Group>
            <StatusItemForm label="Low stock" value="created" />
          </Checkbox.Group>
        </Form.Item>
      )}
    </div>
  );
};

export default FilterBodyForm;
